import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import Door from "../../assets/images/door.png";

export default function Niche({ onFinish }) {
  const doorRef = useRef();
  const containerRef = useRef();
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    gsap.set(doorRef.current, {
      scale: 1,
      transformOrigin: "center",
    });
  }, []);

  const handleClick = () => {
    if (clicked) return;
    setClicked(true);

    const tl = gsap.timeline();

    tl.to(doorRef.current, {
      scale: 50, // Large enough to go off-screen on any display
      duration: 4,
      ease: "power4.inOut",
    });

    tl.to(
      containerRef.current,
      {
        opacity: 0,
        duration: 0.8,
        ease: "power1.out",
        onComplete: () => {
          containerRef.current.style.display = "none";
          onFinish();
        },
      },
      "-=0.5"
    );
  };

  return (
    <div
      ref={containerRef}
      onClick={handleClick}
      className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center cursor-pointer transition-opacity duration-1000"
    >
      <img
        ref={doorRef}
        src={Door}
        alt="door"
        className="w-40 md:w-60"
        style={{
          willChange: "transform",
          perspective: "1000px",
        }}
      />
      <p
        style={{
          fontFamily: "Playfair Display, sans-serif",
          fontWeight: "bold",
          zIndex: 100,
        }}
        className="text-white text-center p-6 mt-6 text-lg md:text-3xl  "
      >
        Unlock the True Value of Your Property — No Compromises?
      </p>
      <p className="text-white text-sm mt-1">(Tap the door to enter)</p>
    </div>
  );
}
